import { MemoizedSelector, createFeatureSelector, createSelector } from '@ngrx/store';
import { StateUtils } from '@spartacus/core';
import { EntriesState, PagesState } from '../../../../../../core/features/store/base-feature-state';
import { PyStateUtils } from '../../../../../../core/state';
import { News, NewsPage } from '../../model';
import { NEWS_FEATURE, NewsState, StateWithNews } from '../news-state';

export const getNewsState: MemoizedSelector<StateWithNews, NewsState> = createFeatureSelector<NewsState>(NEWS_FEATURE);

export const getEntitiesState: MemoizedSelector<StateWithNews, EntriesState<News>> = createSelector(
  getNewsState,
  (state: NewsState) => state?.entities ?? undefined
);

export const getPagesState: MemoizedSelector<StateWithNews, PagesState<StateUtils.LoaderState<NewsPage>>> = createSelector(
  getNewsState,
  (state: NewsState) => state?.pages ?? undefined
);

export const getDetailedPageState = (count: string): MemoizedSelector<StateWithNews, StateUtils.LoaderState<NewsPage>> =>
  createSelector(
    getPagesState,
    (pagesState: PagesState<StateUtils.LoaderState<NewsPage>>) =>
      (pagesState && pagesState[count]) || PyStateUtils.initialLoaderState
  );

export const getDetailedPageValue = (count: string): MemoizedSelector<StateWithNews, NewsPage> =>
  createSelector(getDetailedPageState(count), (detailedPageState: StateUtils.LoaderState<NewsPage>) => {
    return (detailedPageState && StateUtils.loaderValueSelector(detailedPageState)) || undefined;
  });

export const getIdsFromDetailedPageValue = (count: string): MemoizedSelector<StateWithNews, string[]> =>
  createSelector(getDetailedPageValue(count), (newsPage: NewsPage) => {
    return (newsPage && newsPage.ids) || [];
  });

export const getNews = (count: string): MemoizedSelector<StateWithNews, News[]> =>
  createSelector(getIdsFromDetailedPageValue(count), getEntitiesState, (ids: string[], entities: EntriesState<News>) => {
    if (!!ids && !!entities) {
      return ids.map((id) => entities[id]);
    }

    return [];
  });
